import { PaymentMethod } from '@repo/common';
import { z } from 'zod';

export const AddPaymentEntrySchema = z.object({
    amount: z.coerce.number().min(0),
    payment_method: z.nativeEnum(PaymentMethod),
    transaction_id: z.string().default(''),
});

export const AddPaymentFormSchema = z.object({
    payments: z.array(AddPaymentEntrySchema).min(1),
});

export type TAddPaymentForm = z.infer<typeof AddPaymentFormSchema>;

export const INITIAL_VALUE: Partial<TAddPaymentForm> = {
    payments: [
        {
            // @ts-expect-error initial value
            amount: undefined,
            payment_method: PaymentMethod.CASH,
            transaction_id: '',
        },
    ],
};
